﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Mate } from "@models/configurators/output-fields/cad/mates/mate";
import { ICadAngleMate } from "@models/entity-models";
import { eOutputFieldType } from "@models/enums";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadAngleMate, eOutputFieldType.cadAngleMate)
export class CadAngleMate extends Mate implements ICadAngleMate {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public angle: number;
}
